import React from 'react';
import { Box, ContentContainer, Stack } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';
import Layout from './Layout';
import { metaOverrideSet } from '../metaOverride';

const Content = ({ errors }) => {
  const { resource } = useMetaLayoutContext();

  return (
    <Box>
      <ContentContainer maxWidth={'md'}>
        <Stack direction={'column'} alignItems={'center'} spacing={3}>
          <MetaResourceRenderer
            resource={resource}
            layout={Layout}
            LayoutProps={{
              errors,
            }}
            metaOverrideSet={metaOverrideSet}
          />
        </Stack>
      </ContentContainer>
    </Box>
  );
};

Content.defaultProps = {
  errors: [],
};

Content.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object),
};

export default Content;
